module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTUxMiAxNjBjMTMxLjIgMCAyMzkuNCA5OC44IDI1NC4zIDIyNmEyMjQgMjI0IDAgMCAxLTIyLjYgNDQ1LjlMNzM2IDgzMkgyODhhMjI0IDIyNCAwIDAgMS0zMC4yLTQ0NkEyNTYgMjU2IDAgMCAxIDUxMiAxNjB6IG02NCAyOTMuNWgtMTI4djE0Ni44aC03OC40YTE2IDE2IDAgMCAwLTExLjMgMjcuM2wxMzEuMSAxMzEuMWEzMiAzMiAwIDAgMCA0NS4yIDBsMTMxLjEtMTMxLjFhMTYgMTYgMCAwIDAtMTEuMy0yNy4zbC03OC40IDB2LTE0Ni44eiIgZmlsbD0iIzAiIHAtaWQ9IjQzMjciPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Cloud download-filled.svg
// module id = SqBQ
// module chunks = 73